import {
  selectIsJourneyGoalsFeatureFlagOn,
  selectIsMissionControlHomepageAndBetaFeatureFlagOn,
} from 'core/userContext';
import { addGoalsToOptions } from 'modules/campaigns/lib/components/ConversionSelect/ConversionSelect.utils';
import { getJourneyCurrentConversionEventName } from 'modules/workflows/ducks';
import { useSelector } from 'react-redux';
import { match } from 'ts-pattern';
import { MultiFilterSelect } from 'ui/selects';
import { useAllowedCustomEventOptions } from 'utils/hooks/useCustomEvents';
import noop from 'utils/noop';

interface MultiConversionDropdownProps {
  values?: string[];
  onChange?: (value: string[]) => void;
  isDisabled?: boolean;
  isError?: boolean;
}

export const MultiConversionDropdown = (props: MultiConversionDropdownProps) => {
  const isJourneyGoalsEnabled = useSelector(selectIsJourneyGoalsFeatureFlagOn);
  const isMissionControlAndBetaEnabled = useSelector(
    selectIsMissionControlHomepageAndBetaFeatureFlagOn,
  );
  const journeyEventName = useSelector(getJourneyCurrentConversionEventName);

  // TODO: Add project goals event names once the backend is ready.
  const projectGoalsEventNames: string[] = []; // MOCK_PROJECT_GOALS.map((goal) => goal.conversions?.[0]?.eventName); // feel free to uncomment for testing

  const { values = [], onChange = noop, isDisabled, isError } = props;
  const customEventOptions = useAllowedCustomEventOptions();

  const options = match({ isJourneyGoalsEnabled, isMissionControlAndBetaEnabled })
    .with({ isJourneyGoalsEnabled: true, isMissionControlAndBetaEnabled: true }, () =>
      addGoalsToOptions(customEventOptions, journeyEventName, projectGoalsEventNames),
    )
    .with({ isJourneyGoalsEnabled: false, isMissionControlAndBetaEnabled: true }, () =>
      addGoalsToOptions(customEventOptions, undefined, projectGoalsEventNames),
    )
    .with({ isJourneyGoalsEnabled: true, isMissionControlAndBetaEnabled: false }, () =>
      addGoalsToOptions(customEventOptions, journeyEventName, []),
    )
    .otherwise(() => customEventOptions);

  return (
    <MultiFilterSelect
      content={{ clearText: 'Clear', selectNone: 'Select none', selectAll: 'Select all' }}
      defaultValues={values}
      placeholder={'Search or select an event'}
      inputContent={{ filterPlaceholder: 'Search all conversions' }}
      onSelect={(vals) => onChange(vals as string[])}
      id={'conversions-multiselect'}
      options={options}
      groupBySelectedOptions
      isDisabled={isDisabled}
      isError={isError}
      isFullWidth
    />
  );
};

export default MultiConversionDropdown;
